exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".userRow[data-v-73eb4723]{display:flex;margin-top:5px;padding:5px;align-items:center;cursor:pointer;background:transparent;transition:.2s}.userRow[data-v-73eb4723]:hover{background:hsla(0,0%,100%,.1)}.userRow strong[data-v-73eb4723]{margin-left:13px;font-weight:500;color:var(--white);opacity:.7;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.userRow .avatar[data-v-73eb4723]{width:32px;height:32px;border-radius:50%;flex-shrink:0;background:var(--primary)}.userRow .avatar.bot-avatar[data-v-73eb4723]{background:var(--mention-detail)}.userRow .bot[data-v-73eb4723]{margin-left:9px;background-color:var(--discord);color:var(--white);border-radius:4px;padding:4px 5px;text-transform:uppercase;font-size:11px;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-73eb4723","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/User-List/UserRow.vue
// module id = 95
// module chunks = 0